'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'house';
var width = 512;
var height = 512;
var aliases = [127968,63498,63500,"home","home-alt","home-lg-alt"];
var unicode = 'f015';
var svgPathData = 'M256.3-2.9l5.5 5.1 240 224 5.8 5.5-10.9 11.7-5.8-5.5-26.5-24.8 0 298.9-416 0 0-298.9c-21.1 19.7-31.9 29.8-32.4 30.2l-10.9-11.7 5.8-5.5 240-224 5.5-5.1zm0 21.9l-192 179.2 0 297.9 112 0 0-176 160 0 0 176 112 0 0-297.9-192-179.2zM192.3 496l128 0 0-160-128 0 0 160z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouse = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;